
import React from 'react';


export const attributes = {"name":"General CRM Training","order":2};
export default function() {
  return (
    <div>
      <h2>General CRM Training</h2>
<p>If you are new to the CRM platform, before reviewing this guide and related training you must complete the general introduction training offered by Microsoft. This training is offered as online videos that take you through the basics of the CRM system along with &quot;hands-on&quot; lessons on how to accomplish basic CRM tasks.</p>
<p>You will learn what the base CRM entities are, the terminology used in the CRM system and how to perform common CRM tasks. This information will make it possible for you to learn about the Premiere Suites customizations with the content here.</p>
<p><a href="https://mva.microsoft.com/en-US/training-courses/introduction-to-microsoft-dynamics-365-17593?l=J6OdOYtqD_906312570">Microsoft Virtual Training</a></p>

    </div>
  );
};


// WEBPACK FOOTER //
// ../content/pages/welcome-to-premiere-crm/welcome-to-crm/general-crm-tutorials.md